export enum InvoiceStatus {
    DRAFT = 'DRAFT',
    CREATED = 'CREATED',
    UNAPPROVED = 'UNAPPROVED',
    APPROVED = 'APPROVED',
    CANCELED = 'CANCELED',
    REJECTED = 'REJECTED',
    PAID = 'PAID',
}
